import { safestTimeToDriveElements } from './elements.min.js';
import { sBanner } from '../../shared.min.js';
import { ClockHandler } from './clockHandler.min.js';
import { FormHandler } from './formHandler.min.js';
import { TimeRangeFormatHelper } from './timeRangeFormatHelper.min.js';

const safestTimeToDrive = {
	elements: safestTimeToDriveElements,
	screens: null,

	clockHandlerInstance: null,
	formHandlerInstance: null,

	safestTimeToDriveData: {},
	additionalAreaCountries: [],
	timeRangeFormatHelperInstance: null,

	init: async function () {
		this.getWidgetScreens();
		this.initialiseBanner();

		await this.getSafestTimeToDriveData();

		this.initialiseSafestTimeToDriveHelpers();
		this.initialiseClockHandler();
		this.initialiseFormHandler();
	},

	initialiseBanner: function () {
		const bannerTitleOne = this.elements.banner.container.getAttribute('data-banner-title-one');
		const bannerTitleTwo = this.elements.banner.container.getAttribute('data-banner-title-two');

		sBanner(
			this.elements.widget,
			[bannerTitleOne, bannerTitleTwo],
			'.banner-current-text',
			'.banner-current-progress',
			'.banner__progress-bar__bar',
			1
		);
	},

	getWidgetScreens: function () {
		this.screens = this.elements.widget.querySelectorAll('.widget__screen');
	},

	initialiseSafestTimeToDriveHelpers: function () {
		this.timeRangeFormatHelperInstance = new TimeRangeFormatHelper();
	},

	initialiseFormHandler: async function () {
		this.formHandlerInstance = new FormHandler({
			elements: this.elements,
			clockHandlerInstance: this.clockHandlerInstance,
			safestTimeToDriveData: this.safestTimeToDriveData,
			additionalAreaCountries: this.additionalAreaCountries,
			screens: this.screens,
			formatTimeRangeHelper: this.timeRangeFormatHelperInstance,
		});

		this.formHandlerInstance.initialiseEventListeners();
	},

	initialiseClockHandler: function () {
		this.clockHandlerInstance = new ClockHandler({
			elements: this.elements,
			selectedLocationData: this.selectedLocationData,
			formatTimeRangeHelper: this.timeRangeFormatHelperInstance,
		});

		this.clockHandlerInstance.initialiseClockPaths();
		this.clockHandlerInstance.initialiseClockToggle();
	},

	fetchJsonData: async function (url) {
		const response = await fetch(url);
		if (!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}
		return response.json(); // parse JSON
	},

	getSafestTimeToDriveData: async function () {
		const dataElement = this.elements.data;
		const safestTimeToDriveUrl = dataElement.getAttribute('data-json-data');

		try {
			const data = await this.fetchJsonData(safestTimeToDriveUrl);
			//set formatted data
			this.safestTimeToDriveData = this.formatSafestTimeToDriveData(data.safestTimeToDriveData);
			//get additional area countries - flat list for area autocomplete setup
			this.getAdditionalAreaCountries(this.safestTimeToDriveData);
		} catch (error) {
			console.error('Error fetching JSON data:', error);
		}
	},

	getAdditionalAreaCountries: function (safestTimeToDriveData) {
		const keys = [];
		for (const [key, value] of Object.entries(safestTimeToDriveData)) {
			if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
				// Check if this object has any nested arrays
				const hasNestedArray = Object.values(value).some(v => Array.isArray(v));
				if (hasNestedArray) keys.push(key);
			}
		}
		this.additionalAreaCountries = keys;
	},

	formatSafestTimeToDriveData: function (data) {
		if (Array.isArray(data)) return data;

		if (typeof data === 'object' && data !== null) {
			// Object case: transform each key
			const formatted = {};
			for (const [key, value] of Object.entries(data)) {
				const newKey = key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
				formatted[newKey] = this.formatSafestTimeToDriveData(value);
			}
			return formatted;
		}

		// Primitive case: return as is
		return data;
	},
};

document.addEventListener('DOMContentLoaded', function () {
	safestTimeToDrive.init();
});
